export default function applyCustomization() {
    ko.numericObservable = (initialValue) => {
        let _actual = ko.observable(initialValue);

        let result = ko.computed({
            read: () => {
                return _actual();
            },
            write: (newValue) => {
                let parsedValue = parseFloat(newValue + '');
                _actual(isNaN(parsedValue) ? newValue : parsedValue);
            }
        });

        return result;
    };
};